var exports = {
  "Zd": "AuthIdentifierFirstStep.module__form___Z0NncV",
  "aJ": "AuthIdentifierFirstStep.module__formAfterHeader___Z0NncV",
  "h_": "AuthIdentifierFirstStep.module__description___Z0NncV",
  "Uy": "AuthIdentifierFirstStep.module__quietActions___Z0NncV",
  "uX": "AuthIdentifierFirstStep.module__textButton___Z0NncV",
  "aK": "AuthIdentifierFirstStep.module__hint___Z0NncV",
  "qx": "AuthIdentifierFirstStep.module__hintError___Z0NncV",
  "Vo": "AuthIdentifierFirstStep.module__alternatives___Z0NncV",
};

module.exports = exports;
